import React, { useEffect } from "react";
import Grid from '@mui/material/Grid';
import { Box } from "@mui/system";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import { Button } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function IslandCabinetryForm({
    steps,
    activeStep,
    handleBack,
    handleNext,
    cabinetryFinishes,
    Cabinetry,
    CabinetrySave,
    Customer
}) {
    let [dimension, setDimension] = React.useState({});

    const [error, setError] = React.useState({
        dimensionA: null,
        dimensionC: null,
        dimensionD: null,
        dimensionE: null,
        dimensionF: null,
    });

    useEffect(() => {
        DataProcessing(dimension);
    }, [dimension]);

    useEffect(() => {
        if(Cabinetry){
            DataFetching(Cabinetry);
        }
    },[])

    const DataFetching = (data) => {
        for ( var property in data ) {
            if(property === "dimensionB"){
                const finddata = cabinetryFinishes.findIndex(item => {return data.dimensionB.id === item.id});
                setDimension(prevState => ({ ...prevState, ['dimensionB'] : cabinetryFinishes[finddata] }));
            } else if(property === "dimensionI"){
                const finddata = cabinetryFinishes.findIndex(item => {return data.dimensionI.id === item.id});
                setDimension(prevState => ({ ...prevState, ['dimensionI'] : cabinetryFinishes[finddata] }));
            } else if(property === "dimensionA"){
                setDimension(prevState => ({ ...prevState, ["dimensionA"] : data.dimensionA }));
            } else if(property === "dimensionD"){
                setDimension(prevState => ({ ...prevState, ["dimensionD"] : data.dimensionD }));
            } else if(property === "dimensionE"){
                setDimension(prevState => ({ ...prevState, ["dimensionE"] : data.dimensionE }));
            } else if(property === "dimensionC"){
                if(booleanIdentifier(data.checkedA)){
                    setDimension(prevState => ({ ...prevState, ["dimensionC"] : data.dimensionC }));
                } else {
                    setDimension(prevState => ({ ...prevState, ["dimensionC"] : 0 }));
                }
            } else if(property === "dimensionF"){
                if(booleanIdentifier(data.checkedB)){
                    setDimension(prevState => ({ ...prevState, ["dimensionF"] : data.dimensionF }));
                } else {
                    setDimension(prevState => ({ ...prevState, ["dimensionF"] : 0 }));
                }
            } else if(property === "dimensionG"){
                setDimension(prevState => ({ ...prevState, ["dimensionG"] : data.dimensionG }));
            } else if(property === "dimensionH"){
                setDimension(prevState => ({ ...prevState, ["dimensionH"] : data.dimensionH }));
            } else if(property === "dimensionJ"){
                if(booleanIdentifier(data.checkedC)){
                    setDimension(prevState => ({ ...prevState, ["dimensionJ"] : data.dimensionJ }));
                } else {
                    setDimension(prevState => ({ ...prevState, ["dimensionJ"] : 0 }));
                }
            } else if(property === "dimensionL"){
                const finddata = cabinetryFinishes.findIndex(item => {return data.dimensionL.id === item.id});
                setDimension(prevState => ({ ...prevState, ["dimensionL"] : cabinetryFinishes[finddata] }));
            } else if(property === "dimensionK"){
                setDimension(prevState => ({ ...prevState, ["dimensionK"] : data.dimensionK }));
            } else if(property === "cabinatry_cost") {
                setDimension(prevState => ({ ...prevState, ["cabinatry_cost"] : data.cabinatry_cost }));
            } else if(property === "sqftOfBase"){
                setDimension(prevState => ({ ...prevState, ["sqftOfBase"] : data.sqftOfBase }));
            } else if(property === "sqftOfWall"){
                setDimension(prevState => ({ ...prevState, ["sqftOfWall"] : data.sqftOfWall }));
            } else if(property === "sqftOfTall"){
                setDimension(prevState => ({ ...prevState, ["sqftOfTall"] : data.sqftOfTall }));
            } else if(property === "checkedA"){
                setDimension(prevState => ({ ...prevState, ["checkedA"] : booleanIdentifier(data.checkedA) }));
            } else if(property === "checkedB"){
                setDimension(prevState => ({ ...prevState, ["checkedB"] : booleanIdentifier(data.checkedB) }));
            } else if(property === "checkedC"){
                setDimension(prevState => ({ ...prevState, ["checkedC"] : booleanIdentifier(data.checkedC) }));
            } else if(property === "cabinatry_cost"){
                setDimension(prevState => ({ ...prevState, ["cabinatry_cost"] : data.cabinatry_cost }));
            } else {

            }
        }
    }

    const booleanIdentifier = (data) => {
        if(data === '1'){
            return true;
        }
        if(data === '0'){
            return false;
        }
    }

    const DataProcessing = (data) => {
        dimensionGEvent(data.dimensionA || 0, data.dimensionJ || 0, data.dimensionF || 0,data.dimensionD || 0, data.checkedB);
        dimensionHEvent(data.dimensionA || 0, data.dimensionJ || 0, data.dimensionC || 0,data.dimensionE || 0, data.checkedA);
        dimensionKEvent(data.dimensionJ || 0, data.checkedC);
        sqftOfBaseEvent(data.dimensionA || 0, data.dimensionJ || 0,data.dimensionF || 0,data.dimensionD || 0, data.checkedB);
        sqftOfWallEvent(data.dimensionA || 0, data.dimensionJ || 0,data.dimensionC || 0,data.dimensionE || 0, data.checkedA);
        sqftOfTallEvent(data.dimensionJ || 0, data.checkedC);
        TotalCostEvent(data.sqftOfBase || null, data.dimensionB || cabinetryFinishes[0], data.sqftOfWall || null, data.dimensionI  || cabinetryFinishes[0], data.sqftOfTall || null, data.dimensionL  || cabinetryFinishes[0]);
    }

    const dimensionKEvent = (dimensionJ, status) => {
        if(status){
            setDimension(prevState => ({ ...prevState, ['dimensionK']: dimensionJ +" X "+ 210 }));
        } else {
            setDimension(prevState => ({ ...prevState, ['dimensionK']: 0 +" X "+ 210 }));
            setDimension(prevState => ({ ...prevState, ['dimensionJ']: '0' }));
        }

    }

    const sqftOfTallEvent = (dimensionJ, status) => {
        if(status){
            setDimension(prevState => ({ ...prevState, ['sqftOfTall']: (((parseInt(dimensionJ) * 210)) / 900).toFixed(4) }));
        } else {
            setDimension(prevState => ({ ...prevState, ['sqftOfTall']: 0.00 }));
        }
    }

    const dimensionGEvent = (dimensionA, dimensionJ ,dimensionF, dimensionD, status) => {
        if(status){
            if(parseInt(dimensionA) > parseInt(dimensionF)){
                setDimension(prevState => ({ ...prevState, ['dimensionG']: (parseInt(dimensionA) - parseInt(dimensionJ) - parseInt(dimensionF))+" X "+ dimensionD }));
            } else {
                setDimension(prevState => ({ ...prevState, ['dimensionF']: '0' }));
            }
        } else {
            setDimension(prevState => ({ ...prevState, ['dimensionG']: (parseInt(dimensionA) - parseInt(dimensionJ)) +" X "+ dimensionD }));
        }
    }

    const dimensionHEvent = (dimensionA, dimensionJ, dimensionC, dimensionE, status) => {
        if(status){
            if(parseInt(dimensionA) > parseInt(dimensionC)){
                setDimension(prevState => ({ ...prevState, ['dimensionH']: (parseInt(dimensionA) - parseInt(dimensionJ) - parseInt(dimensionC))+" X "+ dimensionE }));
            } else {
                setDimension(prevState => ({ ...prevState, ['dimensionC']: '0' }));
            }
        } else {
            setDimension(prevState => ({ ...prevState, ['dimensionH']: (parseInt(dimensionA) - parseInt(dimensionJ)) +" X "+ dimensionE }));
        }
    }

    const sqftOfBaseEvent = (dimensionA, dimensionJ, dimensionF, dimensionD, status) => {
        if(status){
            setDimension(prevState => ({ ...prevState, ['sqftOfBase']: (((parseInt(dimensionA) - parseInt(dimensionJ) - parseInt(dimensionF)) * dimensionD) / 900).toFixed(4) }));
        } else {
            setDimension(prevState => ({ ...prevState, ['sqftOfBase']: (((parseInt(dimensionA) - parseInt(dimensionJ)) * dimensionD) / 900).toFixed(4) }));
        }
    }

    const sqftOfWallEvent = (dimensionA, dimensionJ, dimensionC, dimensionE, status) => {
        if(status){
            setDimension(prevState => ({ ...prevState, ['sqftOfWall']: (((parseInt(dimensionA) - parseInt(dimensionJ) - parseInt(dimensionC)) * dimensionE) / 900).toFixed(4) }));
        } else {
            setDimension(prevState => ({ ...prevState, ['sqftOfWall']: (((parseInt(dimensionA) - parseInt(dimensionJ)) * dimensionE) / 900).toFixed(4) }));
        }
    }

    const TotalCostEvent = (sqftOfBase, dimensionB, sqftOfWall, dimensionI, sqftOfTall, dimensionL) => {
        if(sqftOfBase && sqftOfWall && sqftOfTall == '0'){
            setDimension(prevState => ({ ...prevState, ['cabinatry_cost']: ((parseFloat(sqftOfBase) * parseInt(dimensionB.price)) + (parseFloat(sqftOfWall) * parseInt(dimensionI.price)))}));
        } else if(sqftOfBase && sqftOfWall && sqftOfTall){
            setDimension(prevState => ({ ...prevState, ['cabinatry_cost']: ((parseFloat(sqftOfBase) * parseInt(dimensionB.price)) + (parseFloat(sqftOfWall) * parseInt(dimensionI.price)) + (parseFloat(sqftOfTall) * parseInt(dimensionL.price)) )}));
        } else {
            setDimension(prevState => ({ ...prevState, ['cabinatry_cost']: (parseInt(dimensionB.price) + parseInt(dimensionI.price)) }));
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        dimension.customer = Customer;
        CabinetrySave(dimension);
        handleNext();
    }

    const handleChange = (e) => {
        if(e.target.name === "checkedB" || e.target.name === "checkedA" || e.target.name === "checkedC") {
            setDimension(prevState => ({ ...prevState, [e.target.name]: e.target.checked }));
        } else {
            setDimension(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
        }
    }

    return (
        <Box
            component={'form'}
            noValidate
            autoComplete="off"
            mt={3}
        >
            <Grid container spacing={2}>
                <Grid container mt={2} xs={12} sm={8}>
                    <Grid container xs={12} sm={8}>
                        <Grid item xs={12} sm={12}>
                            <Box component={'div'} mx={'auto'} mb={2} width={"95%"}>
                                <TextField
                                    required
                                    fullWidth
                                    type={'number'}
                                    label="Enter Dimensions of Wall (In cm)"
                                    name="dimensionA"
                                    autoFocus
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    value={dimension.dimensionA || 0}
                                    onChange={handleChange}
                                    error={error.dimensionA ? true : false}
                                    helperText={error.dimensionA ? error.dimensionA : ""}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"}>
                                <TextField
                                    required
                                    fullWidth
                                    type={'number'}
                                    label="Enter the height of the Base cabinets (In cm)"
                                    autoFocus
                                    name="dimensionD"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    value={dimension.dimensionD || 0}
                                    onChange={handleChange}
                                    error={error.dimensionD ? true : false}
                                    helperText={error.dimensionD ? error.dimensionD : ""}
                                />
                            </Box>
                            <Box component={'div'} mx={'auto'} width={"90%"}>
                                <TextField
                                    select
                                    label="Choose the finish Required"
                                    fullWidth
                                    name='dimensionB'
                                    value={dimension.dimensionB || cabinetryFinishes[0]}
                                    align="left"
                                    onChange={handleChange}
                                    helperText=""
                                >
                                    {cabinetryFinishes.map((item) => (
                                        <MenuItem key={item.id} value={item}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"}>
                                <TextField
                                    required
                                    fullWidth
                                    type={'number'}
                                    label="Enter the height of the Wall cabinets (In cm)"
                                    autoFocus
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    name="dimensionE"
                                    value={dimension.dimensionE || 0}
                                    onChange={handleChange}
                                    error={error.dimensionE ? true : false}
                                    helperText={error.dimensionE ? error.dimensionE : ""}
                                />
                            </Box>
                            <Box component={'div'} mx={'auto'} width={"90%"}>
                                <TextField
                                    select
                                    label="Choose the finish Required"
                                    fullWidth
                                    name="dimensionI"
                                    value={dimension.dimensionI || cabinetryFinishes[0]}
                                    align="left"
                                    onChange={handleChange}
                                    helperText=""
                                >
                                    {cabinetryFinishes.map((item) => (
                                        <MenuItem key={item.id} value={item}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"} align="left">
                                Is there any fridge or cooking range occupying the wall?
                                <Switch
                                    name='checkedB'
                                    checked={dimension.checkedB || false}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </Box>
                            {dimension.checkedB ?
                                <Box component={'div'} mx={'auto'} width={"90%"}>
                                    <TextField
                                        required
                                        fullWidth
                                        type={'number'}
                                        label="Enter the width that getting occupied (In cm)"
                                        autoFocus
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        name="dimensionF"
                                        value={dimension.dimensionF || 0}
                                        onChange={handleChange}
                                        error={error.dimensionF ? true : false}
                                        helperText={error.dimensionF ? error.dimensionF : ""}
                                    />
                                </Box>
                                : ""}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"} align="left">
                                Is there any chimney provision or window in the wall
                                <Switch
                                    name='checkedA'
                                    checked={dimension.checkedA || false}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </Box>
                            {dimension.checkedA ?
                                <Box component={'div'} mx={'auto'} mb={2} width={"90%"}>
                                    <TextField
                                        required
                                        fullWidth
                                        type={'number'}
                                        label="Please enter the dimension that's occupying (In cm)"
                                        autoFocus
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        name="dimensionC"
                                        value={dimension.dimensionC || 0}
                                        onChange={handleChange}
                                        error={error.dimensionC ? true : false}
                                        helperText={error.dimensionC ? error.dimensionC : ""}
                                    />
                                </Box>
                                : ""}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box component={'div'} mx={'auto'} mb={2} width={"90%"} align="left">
                            Do you need a Tall unit?
                            <Switch
                                name='checkedC'
                                checked={dimension.checkedC || false}
                                onChange={handleChange}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Box>
                        {dimension.checkedC ?
                            <>
                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"}>
                                <TextField
                                    required
                                    fullWidth
                                    type={'number'}
                                    label="Please enter the dimension that's occupying (In cm)"
                                    autoFocus
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    name="dimensionJ"
                                    value={dimension.dimensionJ || 0}
                                    onChange={handleChange}
                                />
                            </Box>

                            <Box component={'div'} mx={'auto'} mb={2} width={"90%"}>
                            <TextField
                                select
                                label="Choose the finish Required"
                                fullWidth
                                name="dimensionL"
                                value={dimension.dimensionL || cabinetryFinishes[0]}
                                align="left"
                                onChange={handleChange}
                                helperText=""
                            >
                                {cabinetryFinishes.map((item) => (
                                    <MenuItem key={item.id} value={item}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                            </Box>
                            </>
                            : ""}
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4}>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Total Area of Base Cabinets:
                                </TableCell>
                                <TableCell align="right">
                                    {dimension.dimensionG || 0+" X "+0}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Total Area of Wall Cabinets:
                                </TableCell>
                                <TableCell align="right">
                                    {dimension.dimensionH || 0+" X "+0}
                                </TableCell>
                            </TableRow>
                            {dimension.checkedC ?
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Total Area of Tall Cabinets:
                                    </TableCell>
                                    <TableCell align="right">
                                        {dimension.dimensionK || 0+" X "+210}
                                    </TableCell>
                                </TableRow>
                            : ""}
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Sqft of Base:
                                </TableCell>
                                <TableCell align="right">
                                    {parseFloat(dimension.sqftOfBase).toFixed(2) || 0.00}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Sqft of Wall:
                                </TableCell>
                                <TableCell align="right">
                                    {parseFloat(dimension.sqftOfWall).toFixed(2) || 0.00}
                                </TableCell>
                            </TableRow>
                            {dimension.checkedC ?
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Sqft of Tall
                                </TableCell>
                                <TableCell align="right">
                                    {parseFloat(dimension.sqftOfTall).toFixed(2) || 0.00}
                                </TableCell>
                            </TableRow>
                            : ""}
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    Total Cabinetry Cost:
                                </TableCell>
                                <TableCell align="right">
                                    ₹ {dimension.cabinatry_cost ? (dimension.cabinatry_cost).toLocaleString('en-IN') : 0}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button
                    color="inherit"
                    disabled={activeStep !== 1 ? true : false}
                    sx={{ mr: 1 }}

                >
                    Close
                </Button>

                <Button variant="contained" onClick={handleSubmit}>
                    {activeStep === steps.length - 1 ? 'Finish' : 'Save and Next'}
                </Button>
            </Box>
        </Box>
    )
}